const TaskList = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0914 13.9212L14.0016 19.011L11.5 19.5114L12.0003 17.0098L17.0908 11.9199C17.6418 11.369 18.5351 11.369 19.0861 11.9199L19.0921 11.9259C19.6428 12.4771 19.6425 13.3704 19.0914 13.9212Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M7.49609 11.006H13.4998" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.49609 13.5076H11.4986" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.49609 16.0092H9.49734" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M9.49727 19.5114H5.49477C4.94214 19.5114 4.49414 19.0634 4.49414 18.5107V8.00417C4.49414 7.45154 4.94214 7.00355 5.49477 7.00355H7.997C7.997 5.62197 9.11698 4.50198 10.4986 4.50198C11.8801 4.50198 13.0001 5.62197 13.0001 7.00355H15.5017C16.0543 7.00355 16.5023 7.45154 16.5023 8.00417V9.50511"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.4982 6.50324C10.6364 6.50324 10.7484 6.61523 10.7484 6.75339C10.7484 6.89155 10.6364 7.00355 10.4982 7.00355C10.36 7.00355 10.248 6.89155 10.248 6.75339C10.2479 6.68699 10.2742 6.62326 10.3211 6.57631C10.3681 6.52936 10.4318 6.50306 10.4982 6.50324"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)

export default TaskList
